import appStore from 'redux/stores/app.store';
import httpService from 'services/HttpService';
import { generateURLRappiServices } from 'shared/utils/urls';
import UrlUtils from 'utils/url-utils/UrlUtils';

import type { PartnerId } from 'shared/domain';
import {
  isScheduleTab,
  SCHEDULE_TAB_STORAGE_KEY,
  ScheduleTab,
} from '../../domain';
import {
  CANCEL_SCHEDULED_ORDER_PAYLOAD,
  SCHEDULE_ORDER_API_PATH,
} from '../constants';
import type { ScheduledOrdersRequest } from '../requests';
import type {
  ScheduledOrderDetailResponse,
  ScheduledOrderResponse,
} from '../responses';

function readScheduleOrdersTab(): ScheduleTab {
  const raw = sessionStorage.getItem(SCHEDULE_TAB_STORAGE_KEY);
  const parsed = Number(raw);
  return isScheduleTab(parsed) ? parsed : ScheduleTab.InProgress;
}

function updateScheduleOrdersTab(tab: ScheduleTab): void {
  sessionStorage.setItem(SCHEDULE_TAB_STORAGE_KEY, String(tab));
}

async function readScheduledOrders(
  request: ScheduledOrdersRequest,
): Promise<ScheduledOrderResponse[]> {
  const { data } = await httpService.post<ScheduledOrderResponse[]>(
    generateURLRappiServices({
      url: SCHEDULE_ORDER_API_PATH.list,
    }),
    request,
  );
  return data;
}

async function readScheduledOrderDetail(
  orderId: number,
): Promise<ScheduledOrderDetailResponse> {
  const url = UrlUtils.replaceUrlParams(SCHEDULE_ORDER_API_PATH.orderDetail, {
    orderId,
  });
  const { data } = await httpService.get<ScheduledOrderDetailResponse>(
    generateURLRappiServices({ url }),
  );
  return data;
}

function readPartnerIdFromProfile(): PartnerId {
  return appStore.getPartnerId();
}

async function updateCancelScheduledOrder(params: {
  orderId: number;
  partnerId: PartnerId;
}): Promise<void> {
  const { orderId, partnerId } = params;
  const url = UrlUtils.replaceUrlParams(SCHEDULE_ORDER_API_PATH.cancel, {
    orderId,
    partnerId,
  });
  await httpService.put<void>(
    generateURLRappiServices({ url }),
    CANCEL_SCHEDULED_ORDER_PAYLOAD,
    { headers: { AUTH_OWNER: 1 } },
  );
}

export const scheduleOrderRepository = {
  readScheduleOrdersTab,
  updateScheduleOrdersTab,
  readScheduledOrders,
  readScheduledOrderDetail,
  readPartnerIdFromProfile,
  updateCancelScheduledOrder,
} as const;
